import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { UsersApi, type AddUserAccountsRequest, type ProfileResponse } from '@shared/api';

const addUserAccountsEffect = createEffect((request: AddUserAccountsRequest) => UsersApi.addUserAccounts(request));
const clearEvent = createEvent();

const $dataStore = createStore<ProfileResponse | null>(null)
  .on(addUserAccountsEffect.done, (current, data) => data.result.data || current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(addUserAccountsEffect.pending, (_, data) => data)
  .on(addUserAccountsEffect.fail, () => false)
  .on(addUserAccountsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(addUserAccountsEffect, () => null)
  .on(
    addUserAccountsEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while adding Manager. Please try again.').message,
  )
  .on(addUserAccountsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $addUserAccountsStore = {
  events: {
    addUserAccounts: addUserAccountsEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
